var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 19,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.805 3.098a.9.9 0 0 0-1.61 0l-6.3 12.6a.9.9 0 0 0 1.052 1.268l4.5-1.286a.9.9 0 0 0 .653-.866V10.7a.9.9 0 1 1 1.8 0v4.114a.9.9 0 0 0 .653.866l4.5 1.286a.9.9 0 0 0 1.052-1.268z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/airplane.c99808fa6bbcc6357004db05620a9c69.svg";
export { ForwardRef as ReactComponent };